import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard data */
export const getDashboardStats = async () => {
  const res = await get(`/views-api/get_creator_video_stats`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetDashboardStats = (onSuccess: any, onError: any) => {
  return useQuery('dashboard-stats', getDashboardStats, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetDashboardStats;
